export interface UserEpic {
  id: number;
  subject: string;
  account: string;
}

export function UserEpicFromJSON(json: any): UserEpic {
  return {
    id: json["id"],
    subject: json["subject"],
    account: json["account"],
  };
}
